import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { getConfig } from '@edx/frontend-platform';

import { useModel } from '@src/generic/model-store';
import IgeaPlayerLayout from '@src/igea-player/IgeaPlayerLayout';
import SidebarProvider from './sidebar/SidebarContextProvider';
import NewSidebarProvider from './new-sidebar/SidebarContextProvider';

// IGEA: il corso si rende tutto con il player IGEA (`IgeaPlayerLayout`).
//
// Qui restavano, dopo un `return` anticipato, circa cento righe della vista di
// Open edX mai eseguite — briciole, chat, barre laterali, modali di
// celebrazione, avvisi di sequenza — con lo stato che serviva solo a loro.
// Tolte il 2026-09-29 (igea-frontend-learning #4): il componente fa soltanto
// cio' che fa davvero. La navigazione fra unita' e sequenze la gestisce il
// player, quindi i gestori passati da CoursewareContainer non servono qui.

const Course = ({ courseId, sequenceId, unitId }) => {
  const course = useModel('coursewareMeta', courseId);
  const { isNewDiscussionSidebarViewEnabled } = useModel('courseHomeMeta', courseId);
  const sequence = useModel('sequences', sequenceId);
  const section = useModel('sections', sequence ? sequence.sectionId : null);

  const pageTitleBreadCrumbs = [
    sequence,
    section,
    course,
  ].filter(element => element != null).map(element => element.title);

  const SidebarProviderComponent = isNewDiscussionSidebarViewEnabled ? NewSidebarProvider : SidebarProvider;

  return (
    <SidebarProviderComponent courseId={courseId} unitId={unitId}>
      <Helmet>
        <title>{`${pageTitleBreadCrumbs.join(' | ')} | ${getConfig().SITE_NAME}`}</title>
      </Helmet>
      <IgeaPlayerLayout courseId={courseId} sequenceId={sequenceId} unitId={unitId} />
    </SidebarProviderComponent>
  );
};

Course.propTypes = {
  courseId: PropTypes.string,
  sequenceId: PropTypes.string,
  unitId: PropTypes.string,
};

Course.defaultProps = {
  courseId: null,
  sequenceId: null,
  unitId: null,
};

export default Course;
